import { Injectable } from '@angular/core';
import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class DateRangeValidator {
    validateNotRequiredDateRange(startDateControlName: string, endDateControlName: string): ValidatorFn {
        return (form: FormGroup): ValidationErrors | null => {
            const startDateControl = form.get(startDateControlName);
            const endDateControl = form.get(endDateControlName);

            const startDate = startDateControl.value;
            const endDate = endDateControl.value;
            if (!!startDate && !!endDate && new Date(startDate) > new Date(endDate)) {
                return { 'startDateBiggerThanEnd': 'Start date should be less than End date' }
            }

            return null;
        }
    }
}
